import React from "react";
import { titleCase } from "@/lib/format";

const MAP = {
  // greens
  active: "emerald", confirmed: "emerald", completed: "emerald", approved: "emerald", paid: "emerald",
  resulted: "emerald", reported: "emerald", done: "emerald", dispensed: "emerald", received: "emerald",
  accepted: "emerald", resolved: "emerald", discharged: "emerald", green: "emerald",
  // ambers
  pending: "amber", waiting: "amber", scheduled: "amber", processing: "amber", in_progress: "amber",
  draft: "amber", on_hold: "amber", collected: "amber", submitted: "amber", new: "amber",
  acquired: "amber", recovery: "amber", sent: "amber", yellow: "amber", orange: "amber", urgent: "amber",
  // reds
  cancelled: "rose", rejected: "rose", no_show: "rose", emergency: "rose", stat: "rose", red: "rose",
  // blues / info
  in_treatment: "blue", in_theatre: "blue", ordered: "blue", routine: "blue", blue: "blue",
};

const CLS = {
  emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  rose: "bg-rose-50 text-rose-700 border-rose-200",
  blue: "bg-teal-50 text-teal-700 border-teal-200",
  slate: "bg-slate-100 text-slate-600 border-slate-200",
};

export function StatusBadge({ value, className = "" }) {
  if (value === undefined || value === null || value === "") return <span className="text-slate-400">—</span>;
  const key = String(value).toLowerCase().replace(/\s+/g, "_");
  const tone = MAP[key] || "slate";
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${CLS[tone]} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full bg-current opacity-70`} />
      {titleCase(value)}
    </span>
  );
}
